import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

export const WhatWeBuild = () => {
  const { t } = useLang();
  const { content, L } = useContent();
  const services = content?.services || [];
  return (
    <section className="bg-[#F7F3EC] py-20 lg:py-32" id="build" data-testid="build-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-6">{t.build.eyebrow}</p>
          <h2 className="font-serif text-[#191713] text-3xl sm:text-4xl lg:text-5xl">{t.build.title}</h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.1}>
              <article className="bg-white border border-[#191713]/10 h-full hover:border-[#A6853B]/60 transition-colors duration-300 group overflow-hidden" data-testid={`build-card-${i}`}>
                {item.image && (
                  <div className="overflow-hidden">
                    <img src={item.image} alt={L(item.name)} loading="lazy"
                      className="w-full aspect-[16/10] object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
                  </div>
                )}
                <div className="p-8">
                  <h3 className="font-serif text-2xl text-[#191713]">{L(item.name)}</h3>
                  <p className="mt-3 text-sm text-[#191713]/65 leading-relaxed">{L(item.body)}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Process = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#F7F3EC] pb-20 lg:pb-32" id="process" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="border-t border-[#191713]/10 pt-16 lg:pt-24">
          <Reveal>
            <p className="eyebrow-label mb-6">{t.process.eyebrow}</p>
            <h2 className="font-serif text-[#191713] text-3xl sm:text-4xl lg:text-5xl">{t.process.title}</h2>
          </Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
            {t.process.steps.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.1}>
                <div data-testid={`process-step-${step.n}`}>
                  <div className="flex items-center gap-4">
                    <span className="w-10 h-10 rounded-full border border-[#B8933F] text-[#B8933F] flex items-center justify-center font-serif text-lg">{step.n}</span>
                    <span className="h-px flex-1 bg-[#191713]/10" aria-hidden="true" />
                  </div>
                  <h3 className="mt-6 font-serif text-xl text-[#191713]">{step.title}</h3>
                  <p className="mt-3 text-sm text-[#191713]/70 leading-relaxed">{step.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
